// import React, { useState, useRef } from 'react';
// import { Container, Row, Col, Form, Button, Alert, InputGroup, ToastContainer, Toast, Spinner } from 'react-bootstrap';
// import { FaTimes } from 'react-icons/fa';
// import './CareersPage.css';

// // Local Url

// // const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://192.168.0.83:4001/api/v1';

// // Local Url


// // Live Url

// const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.hrms.kpostindia.com/api/v1';

// // Live Url


// async function submitCareerApplication(formData) {
//   const token = JSON.parse(localStorage.getItem('accessToken') || 'null');

//   const response = await fetch(`${API_BASE_URL}/careers/apply`, {
//     method: 'POST',
//     headers: {
//       // Do NOT set Content-Type manually for multipart/form-data —
//       // the browser sets it automatically with the correct boundary.
//       ...(token ? { Authorization: `Bearer ${token}` } : {}),
//     },
//     body: formData,
//   });

//   let data = null;
//   try {
//     data = await response.json();
//   } catch {
//     // response had no JSON body
//   }

//   if (!response.ok) {
//     const message = (data && (data.message || data.error)) || `Request failed with status ${response.status}`;
//     const error = new Error(message);
//     error.status = response.status;
//     error.payload = data;
//     throw error;
//   }

//   return data;
// }

// const POSITIONS = ['Digital Marketing Executive', 'Motion Graphics Designer', 'Site Engineer', 'Software Developer', 'Sales Executive', 'HR Executive', 'Other'];

// // Department -> Role mapping (dependent dropdown)
// const DEPARTMENT_ROLES = {
//   'Software Development': [
//     'Software Engineer', 'Software Developer', 'Application Developer', 'Full Stack Developer', 'Front-End Developer',
//     'Back-End Developer', 'Web Developer', 'Mobile App Developer', 'Android Developer', 'iOS Developer', 'React Developer',
//     'Angular Developer', 'Vue.js Developer', 'Node.js Developer', '.NET Developer', 'Java Developer', 'Python Developer',
//     'PHP Developer', 'Laravel Developer', 'DevOps Developer', 'Embedded Software Developer', 'Game Developer', 'Blockchain Developer'
//   ],
//   'Software Architecture & Technical Roles': [
//     'Solution Architect', 'Software Architect', 'Enterprise Architect', 'Technical Architect', 'Application Architect',
//     'Cloud Architect', 'Data Architect', 'Integration Architect', 'Technical Lead', 'Engineering Lead', 'Principal Engineer', 'Staff Engineer'
//   ],
//   'QA / Software Testing': [
//     'QA Engineer', 'QA Analyst', 'Software Tester', 'Manual Tester', 'Automation Tester', 'Test Engineer', 'Automation Test Engineer',
//     'Performance Tester', 'Security Tester', 'API Tester', 'Mobile Application Tester', 'QA Lead', 'Test Lead', 'QA Manager', 'Test Manager'
//   ],
//   'UI/UX & Design': [
//     'UI Designer', 'UX Designer', 'UI/UX Designer', 'Product Designer', 'UX Researcher', 'Interaction Designer',
//     'Visual Designer', 'Web Designer', 'Design Lead', 'UX Lead'
//   ],
//   'DevOps / Cloud / Infrastructure': [
//     'DevOps Engineer', 'DevOps Lead', 'Site Reliability Engineer (SRE)', 'Cloud Engineer', 'Cloud Architect', 'Cloud Administrator',
//     'Infrastructure Engineer', 'Infrastructure Architect', 'Build & Release Engineer', 'Release Manager', 'Platform Engineer',
//     'Systems Engineer', 'Systems Administrator', 'Linux Administrator', 'Windows Administrator'
//   ],
//   'Network & IT Infrastructure': [
//     'Network Engineer', 'Network Administrator', 'Network Architect', 'Network Security Engineer', 'Infrastructure Administrator',
//     'IT Infrastructure Manager', 'NOC Engineer', 'NOC Manager', 'Wireless Network Engineer', 'Telecom Engineer',
//     'Datacenter Engineer', 'Datacenter Manager'
//   ],
//   'Database & Data': [
//     'Database Administrator (DBA)', 'Database Developer', 'Database Engineer', 'Database Architect', 'Data Engineer', 'Data Analyst',
//     'Data Scientist', 'Data Architect', 'Big Data Engineer', 'BI Developer', 'Business Intelligence Analyst', 'BI Architect',
//     'ETL Developer', 'Data Warehouse Developer', 'Data Quality Analyst', 'Machine Learning Engineer', 'AI Engineer',
//     'AI/ML Architect', 'MLOps Engineer'
//   ],
//   'Business Analysis / Product': [
//     'Business Analyst', 'IT Business Analyst', 'Systems Analyst', 'Functional Analyst', 'Technical Business Analyst',
//     'Product Analyst', 'Product Manager', 'Technical Product Manager', 'Product Owner', 'Product Lead', 'Project Manager',
//     'Program Manager', 'Scrum Master', 'Agile Coach'
//   ],
//   'Civil Engineering Department': [
//     'Chief Civil Engineer', 'Civil Engineering Manager', 'Civil Project Manager', 'Civil Project Engineer', 'Senior Civil Engineer',
//     'Civil Engineer', 'Junior Civil Engineer', 'Graduate Civil Engineer', 'Site Engineer', 'Senior Site Engineer', 'Site Supervisor',
//     'Construction Manager', 'Construction Engineer', 'Construction Supervisor', 'Structural Engineer', 'Structural Design Engineer',
//     'Senior Structural Engineer', 'Structural Analyst', 'Design Engineer', 'Civil Design Engineer', 'Planning Engineer',
//     'Project Planning Engineer', 'Estimation Engineer', 'Quantity Surveyor', 'Senior Quantity Surveyor', 'Cost Engineer',
//     'Billing Engineer', 'Contracts Engineer', 'Contracts Manager', 'Survey Engineer', 'Land Surveyor', 'Surveyor',
//     'Survey Technician', 'Geotechnical Engineer', 'Geotechnical Consultant', 'Highway Engineer', 'Transportation Engineer',
//     'Infrastructure Engineer', 'Environmental Engineer', 'Water Resources Engineer', 'Hydraulics Engineer', 'Irrigation Engineer',
//     'QA/QC Engineer', 'Civil QA/QC Engineer', 'QA/QC Manager', 'BIM Engineer', 'BIM Modeler', 'BIM Coordinator',
//     'Civil CAD Engineer', 'Civil CAD Designer', 'AutoCAD Draftsman', 'Civil Draftsman', 'Safety Engineer', 'HSE Engineer',
//     'HSE Manager', 'Construction Safety Officer', 'Site Safety Officer', 'Project Coordinator', 'Civil Consultant',
//     'Civil Engineering Consultant'
//   ],
//   'Mechanical Engineering Department': [
//     'Chief Mechanical Engineer', 'Mechanical Engineering Manager', 'Mechanical Project Manager', 'Mechanical Project Engineer',
//     'Senior Mechanical Engineer', 'Mechanical Engineer', 'Junior Mechanical Engineer', 'Graduate Mechanical Engineer',
//     'Mechanical Design Engineer', 'Senior Mechanical Design Engineer', 'Product Design Engineer', 'Product Development Engineer',
//     'Manufacturing Engineer', 'Production Engineer', 'Production Supervisor', 'Production Manager', 'Maintenance Engineer',
//     'Senior Maintenance Engineer', 'Maintenance Manager', 'Maintenance Technician', 'Mechanical QA/QC Engineer', 'Quality Engineer',
//     'Quality Manager', 'HVAC Engineer', 'HVAC Design Engineer', 'HVAC Technician', 'Thermal Engineer', 'Piping Engineer',
//     'Piping Design Engineer', 'Piping Designer', 'Plant Engineer', 'Plant Maintenance Engineer', 'Automotive Engineer',
//     'Automotive Design Engineer', 'Automotive Service Engineer', 'Robotics Engineer', 'Automation Engineer', 'Controls Engineer',
//     'Mechatronics Engineer', 'Mechanical CAD Engineer', 'Mechanical CAD Designer', 'CAD Modeler', 'CAE Engineer',
//     'Simulation Engineer', 'FEA Engineer', 'CFD Engineer', 'Tool Design Engineer', 'Tool & Die Designer', 'Welding Engineer',
//     'Welding Inspector', 'Fabrication Engineer', 'Fabrication Supervisor', 'Mechanical Procurement Engineer',
//     'Installation Engineer', 'Commissioning Engineer', 'Mechanical Inspector', 'Mechanical Draftsman', 'Mechanical Consultant'
//   ],
//   'Human Resources (HR)': [
//     'Chief Human Resources Officer (CHRO)', 'HR Director', 'HR Head', 'HR Manager', 'Assistant HR Manager', 'HR Executive',
//     'Senior HR Executive', 'HR Officer', 'HR Coordinator', 'HR Associate', 'HR Assistant', 'HR Business Partner (HRBP)',
//     'Senior HR Business Partner', 'HR Generalist', 'HR Specialist', 'HR Consultant', 'HR Operations Manager', 'HR Operations Executive',
//     'HR Operations Specialist', 'HR Compliance Manager', 'HR Compliance Specialist', 'HR Analyst', 'HR Data Analyst', 'HR Information Systems (HRIS) Manager',
//     'HRIS Analyst', 'HRIS Administrator', 'HR Intern', 'HR Trainee'
//   ],
//   'Other': [],
// };

// const DEPARTMENTS = Object.keys(DEPARTMENT_ROLES);

// const EXPERIENCE_YEARS = ['Fresher', '0-1 Years', '1-3 Years', '3-5 Years', '5-8 Years', '8-10 Years', '10+ Years', 'Others'];
// const EMPLOYMENT_STATUS = ['Employed', 'Unemployed', 'Serving Notice Period', 'Freelancer'];
// const NOTICE_PERIOD = ['Immediate', '15 Days', '30 Days', '60 Days', '90 Days'];
// const QUALIFICATION = ['High School', 'Diploma', "Bachelor's Degree", "Master's Degree", 'PhD', 'Other'];
// const GRAD_YEARS = Array.from({ length: 40 }, (_, i) => `${new Date().getFullYear() - i}`);
// const HEARD_FROM = ['LinkedIn', 'Naukri', 'Indeed', 'Company Website', 'Employee Referral', 'Social Media', 'Other'];

// const initialState = {
//   fullName: '', email: '', mobile: '', location: '', linkedin: '', portfolioWebsite: '',
//   position: '', department: '', departmentOther: '', role: '', totalExperience: '', totalExperienceOther: '', relevantExperience: '', employmentStatus: '',
//   currentCompany: '', currentDesignation: '', currentCTC: '', expectedCTC: '', noticePeriod: '', availableFrom: '',
//   qualification: '', qualificationOther: '', specialization: '', institution: '', graduationYear: '',
//   keySkills: '', relevantSkillsForPosition: '', yearsRelevantExperience: '', yearsRelevantExperienceOther: '', certifications: '', achievements: '',
//   resume: null, portfolioLink: '', additionalDocs: null,
//   comfortableOffice: '', willingRoleRequirements: '', heardFrom: '', heardFromOther: '', employeeReferralName: '',
//   declarationAccuracy: false, declarationConsent: false,
// };

// const CareersPage = () => {
//   const [form, setForm] = useState(initialState);
//   const [errors, setErrors] = useState({});
//   const [submitted, setSubmitted] = useState(false);
//   const [submitError, setSubmitError] = useState('');
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [showPasteWarning, setShowPasteWarning] = useState(false);
//   const resumeRef = useRef(null);
//   const additionalDocsRef = useRef(null);

//   const blockPaste = (e) => {
//     e.preventDefault();
//     setShowPasteWarning(true);
//   };

//   const blockPasteKey = (e) => {
//     const isPasteShortcut = (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'v';
//     if (isPasteShortcut) {
//       e.preventDefault();
//       setShowPasteWarning(true);
//     }
//   };

//   const clearFile = (fieldName, ref) => {
//     setForm((prev) => ({ ...prev, [fieldName]: null }));
//     if (ref.current) ref.current.value = '';
//     setErrors((prev) => ({ ...prev, [fieldName]: undefined }));
//   };

//   const handleClearForm = () => {
//     setForm(initialState);
//     setErrors({});
//     setSubmitError('');
//     if (resumeRef.current) resumeRef.current.value = '';
//     if (additionalDocsRef.current) additionalDocsRef.current.value = '';
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked, files } = e.target;

//     // When Department changes, reset the dependent Role field
//     if (name === 'department') {
//       setForm((prev) => ({ ...prev, department: value, role: '' }));
//       setErrors((prev) => ({ ...prev, department: undefined, role: undefined }));
//       return;
//     }

//     setForm((prev) => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : type === 'file' ? files[0] : value,
//     }));
//   };

//   const validate = () => {
//     const err = {};
//     const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[a-zA-Z]{2,}([\/?#][^\s]*)?$/i;
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const phoneRegex = /^[0-9]{10}$/;

//     if (!form.fullName.trim()) err.fullName = 'Full Name is required';
//     if (!form.email.trim()) err.email = 'Email is required';
//     else if (!emailRegex.test(form.email)) err.email = 'Enter a valid email';
//     if (!form.mobile.trim()) err.mobile = 'Mobile Number is required';
//     else if (!phoneRegex.test(form.mobile)) err.mobile = 'Enter a valid 10-digit mobile number';
//     if (!form.location.trim()) err.location = 'Current Location / City is required';
//     if (form.linkedin && !urlRegex.test(form.linkedin)) err.linkedin = 'Enter a valid URL';
//     if (form.portfolioWebsite && !urlRegex.test(form.portfolioWebsite)) err.portfolioWebsite = 'Enter a valid URL';

//     if (!form.position) err.position = 'Position Applied For is required';
//     if (!form.department) err.department = 'Department is required';
//     if (form.department === 'Other' && !form.departmentOther.trim()) err.departmentOther = 'Please specify department';
//     if (form.department !== 'Other' && !form.role) err.role = 'Role is required';
//     if (!form.totalExperience) err.totalExperience = 'Total Years of Experience is required';
//     if (form.totalExperience === 'Others' && !form.totalExperienceOther.trim()) err.totalExperienceOther = 'Please specify your experience';
//     if (!form.relevantExperience.trim()) err.relevantExperience = 'Relevant Experience is required';
//     if (!form.employmentStatus) err.employmentStatus = 'Current Employment Status is required';
//     if (form.currentCTC && isNaN(Number(form.currentCTC))) err.currentCTC = 'Enter a valid number';
//     if (!form.expectedCTC.trim()) err.expectedCTC = 'Expected CTC is required';
//     else if (isNaN(Number(form.expectedCTC))) err.expectedCTC = 'Enter a valid number';
//     if (!form.noticePeriod) err.noticePeriod = 'Notice Period is required';
//     if (form.availableFrom && form.availableFrom < new Date().toISOString().split('T')[0]) {
//       err.availableFrom = 'Date cannot be in the past';
//     }

//     if (!form.qualification) err.qualification = 'Highest Qualification is required';
//     if (form.qualification === 'Other' && !form.qualificationOther.trim()) err.qualificationOther = 'Please specify qualification';
//     if (!form.specialization.trim()) err.specialization = 'Specialization / Degree is required';

//     if (!form.keySkills.trim()) err.keySkills = 'Key Skills are required';
//     if (!form.relevantSkillsForPosition.trim()) err.relevantSkillsForPosition = 'This field is required';
//     if (!form.yearsRelevantExperience) err.yearsRelevantExperience = 'Years of Relevant Experience is required';
//     if (form.yearsRelevantExperience === 'Others' && !form.yearsRelevantExperienceOther.trim()) err.yearsRelevantExperienceOther = 'Please specify years of experience';

//     if (!form.resume) err.resume = 'Resume / CV is required';
//     else {
//       const allowed = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
//       if (!allowed.includes(form.resume.type)) err.resume = 'Only PDF/DOC/DOCX allowed';
//       else if (form.resume.size > 5 * 1024 * 1024) err.resume = 'File size must be under 5MB';
//     }
//     if (form.portfolioLink && !urlRegex.test(form.portfolioLink)) err.portfolioLink = 'Enter a valid URL';

//     if (!form.comfortableOffice) err.comfortableOffice = 'Please select a location';
//     if (!form.willingRoleRequirements) err.willingRoleRequirements = 'Please select Yes or No';
//     if (!form.heardFrom) err.heardFrom = 'Please select an option';
//     if (form.heardFrom === 'Other' && !form.heardFromOther.trim()) err.heardFromOther = 'Please specify';
//     if (form.heardFrom === 'Employee Referral' && !form.employeeReferralName.trim()) err.employeeReferralName = 'Please enter referral name';

//     if (!form.declarationAccuracy) err.declarationAccuracy = 'You must certify the information is accurate';
//     if (!form.declarationConsent) err.declarationConsent = 'Consent is required to proceed';

//     return err;
//   };

//   const normalizeUrl = (url) => {
//     if (!url) return '';
//     return /^https?:\/\//i.test(url) ? url : `https://${url}`;
//   };

//   // Build a FormData object matching the backend's expected field names exactly.
//   const buildPayload = () => {
//     const data = new FormData();

//     // Required text fields
//     data.append('fullName', form.fullName);
//     data.append('email', form.email);
//     data.append('mobile', form.mobile);
//     data.append('location', form.location);
//     data.append('position', form.position);
//     data.append('department', form.department === 'Other' ? form.departmentOther : form.department);
//     data.append('totalExperience', form.totalExperience === 'Others' ? form.totalExperienceOther : form.totalExperience);
//     data.append('relevantExperience', form.relevantExperience);
//     data.append('employmentStatus', form.employmentStatus);
//     data.append('expectedCTC', form.expectedCTC);
//     data.append('noticePeriod', form.noticePeriod);
//     data.append('qualification', form.qualification === 'Other' ? form.qualificationOther : form.qualification);
//     data.append('specialization', form.specialization);
//     data.append('keySkills', form.keySkills);
//     data.append('relevantSkillsForPosition', form.relevantSkillsForPosition);
//     data.append('yearsRelevantExperience', form.yearsRelevantExperience === 'Others' ? form.yearsRelevantExperienceOther : form.yearsRelevantExperience);
//     data.append('comfortableOffice', form.comfortableOffice);
//     data.append('willingRoleRequirements', form.willingRoleRequirements);
//     data.append('heardFrom', form.heardFrom === 'Other' ? form.heardFromOther : form.heardFrom);

//     // Required file
//     data.append('resume', form.resume);

//     // Optional fields — only append when they have a value
//     if (form.linkedin) data.append('linkedin', normalizeUrl(form.linkedin));
//     if (form.portfolioWebsite) data.append('portfolioWebsite', normalizeUrl(form.portfolioWebsite));
//     if (form.department !== 'Other' && form.role) data.append('role', form.role);
//     if (form.currentCompany) data.append('currentCompany', form.currentCompany);
//     if (form.currentDesignation) data.append('currentDesignation', form.currentDesignation);
//     if (form.currentCTC) data.append('currentCTC', form.currentCTC);
//     if (form.availableFrom) data.append('availableFrom', form.availableFrom);
//     if (form.institution) data.append('institution', form.institution);
//     if (form.graduationYear) data.append('graduationYear', form.graduationYear);
//     if (form.certifications) data.append('certifications', form.certifications);
//     if (form.achievements) data.append('achievements', form.achievements);
//     if (form.portfolioLink) data.append('portfolioLink', normalizeUrl(form.portfolioLink));
//     if (form.heardFrom === 'Employee Referral' && form.employeeReferralName) {
//       data.append('employeeReferralName', form.employeeReferralName);
//     }
//     if (form.additionalDocs) data.append('additionalDocs', form.additionalDocs);

//     return data;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSubmitError('');

//     const err = validate();
//     setErrors(err);
//     if (Object.keys(err).length !== 0) {
//       // scroll to the first invalid field for convenience
//       const firstErrorField = document.querySelector('.is-invalid');
//       if (firstErrorField) firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
//       return;
//     }

//     setIsSubmitting(true);
//     try {
//       const payload = buildPayload();
//       await submitCareerApplication(payload);

//       setSubmitted(true);
//       setForm(initialState);
//       if (resumeRef.current) resumeRef.current.value = '';
//       if (additionalDocsRef.current) additionalDocsRef.current.value = '';
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     } catch (error) {
//       console.error('Submission error:', error);
//       setSubmitError(error.message || 'Something went wrong while submitting. Please try again.');
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <Container className="careers-page py-5">
//       <div className="careers-header">
//         <p style={{ marginTop: "60px" }} className="mb-3 d-flex justify-content-center eyebrow">Join UEducate</p>
//         <h2 style={{ textAlign: "center" }}>Career Application Form</h2>
//         <p className="subtext">
//           This application is designed to help us understand your professional profile, 
//           skills, experience, qualifications, and career aspirations. 
//           The information provided will be used to assess your suitability 
//           for current or future career opportunities and to support a 
//           fair and effective recruitment process.
//         </p>
//       </div>

//       {submitted && <Alert variant="success" onClose={() => setSubmitted(false)} dismissible>Application submitted successfully! Our team will get back to you shortly.</Alert>}
//       {submitError && <Alert variant="danger" onClose={() => setSubmitError('')} dismissible>{submitError}</Alert>}

//       <Form noValidate onSubmit={handleSubmit}>
//         <div className="form-section">
//           {/* 1. Personal Information */}
//           <div className="section-head"><span className="section-num">01</span><h4>Personal Information</h4></div>
//           <Row>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Full Name *</Form.Label>
//                 <Form.Control type="text" name="fullName" value={form.fullName} onChange={handleChange} isInvalid={!!errors.fullName} />
//                 <Form.Control.Feedback type="invalid">{errors.fullName}</Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Email Id *</Form.Label>
//                 <Form.Control type="email" name="email" value={form.email} onChange={handleChange} isInvalid={!!errors.email} />
//                 <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Mobile Number *</Form.Label>
//                 <Form.Control
//                   type="tel"
//                   name="mobile"
//                   value={form.mobile}
//                   onChange={(e) => {
//                     const digitsOnly = e.target.value.replace(/\D/g, '').slice(0, 10);
//                     setForm((prev) => ({ ...prev, mobile: digitsOnly }));
//                   }}
//                   isInvalid={!!errors.mobile}
//                   placeholder="10-digit number"
//                   maxLength={10}
//                   inputMode="numeric"
//                 />
//                 <Form.Control.Feedback type="invalid">{errors.mobile}</Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Current Location / Address *</Form.Label>
//                 <Form.Control type="text" name="location" value={form.location} onChange={handleChange} isInvalid={!!errors.location} />
//                 <Form.Control.Feedback type="invalid">{errors.location}</Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//           </Row>
//         </div>

//         <div className="form-section">
//           {/* 2. Job Information */}
//           <div className="section-head"><span className="section-num">02</span><h4>Job Information</h4></div>
//           <Row>
//             <Col md={12}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Position Applied For *</Form.Label>
//                 <Form.Control as="textarea" rows={2} name="position" value={form.position} onChange={handleChange} isInvalid={!!errors.position} placeholder="Enter Your Position.." />
//                 <Form.Control.Feedback type="invalid">{errors.position}</Form.Control.Feedback>
//               </Form.Group>
//             </Col>

//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Department *</Form.Label>
//                 <Form.Select name="department" value={form.department} onChange={handleChange} isInvalid={!!errors.department}>
//                   <option value="">Select</option>
//                   {DEPARTMENTS.map((d) => <option key={d} value={d}>{d}</option>)}
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">{errors.department}</Form.Control.Feedback>
//                 {form.department === 'Other' && (
//                   <Form.Control
//                     type="text"
//                     name="departmentOther"
//                     className="mt-2"
//                     placeholder="Please specify department"
//                     value={form.departmentOther}
//                     onChange={handleChange}
//                     isInvalid={!!errors.departmentOther}
//                   />
//                 )}
//                 {errors.departmentOther && <div className="text-danger small mt-1">{errors.departmentOther}</div>}
//               </Form.Group>
//             </Col>

//             {/* Role dropdown - depends on selected Department. Hidden when Department is 'Other' */}
//             {form.department !== 'Other' && (
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Role *</Form.Label>
//                   <Form.Select
//                     name="role"
//                     value={form.role}
//                     onChange={handleChange}
//                     isInvalid={!!errors.role}
//                     disabled={!form.department}
//                   >
//                     <option value="">
//                       {form.department ? 'Select' : 'Select Department First'}
//                     </option>
//                     {(DEPARTMENT_ROLES[form.department] || []).map((r) => (
//                       <option key={r} value={r}>{r}</option>
//                     ))}
//                   </Form.Select>
//                   <Form.Control.Feedback type="invalid">{errors.role}</Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//             )}

//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Total Years of Experience *</Form.Label>
//                 <Form.Select name="totalExperience" value={form.totalExperience} onChange={handleChange} isInvalid={!!errors.totalExperience}>
//                   <option value="">Select</option>
//                   {EXPERIENCE_YEARS.map((y) => <option key={y} value={y}>{y}</option>)}
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">{errors.totalExperience}</Form.Control.Feedback>
//               </Form.Group>
//             </Col>

//             {form.totalExperience === 'Others' && (
//               <>
//                 <Col md={12}>
//                   <Form.Control
//                     type="text"
//                     name="totalExperienceOther"
//                     className="mt-2 mb-4"
//                     placeholder="Please specify"
//                     value={form.totalExperienceOther}
//                     onChange={handleChange}
//                     isInvalid={!!errors.totalExperienceOther}
//                   />
//                 </Col>
//                 {errors.totalExperienceOther && <div className="text-danger small mt-1">{errors.totalExperienceOther}</div>}
//               </>
//             )}

//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Relevant Experience *</Form.Label>
//                 <Form.Control type="text" name="relevantExperience" value={form.relevantExperience} onChange={handleChange} isInvalid={!!errors.relevantExperience} placeholder="e.g. 2 years in Digital Marketing" />
//                 <Form.Control.Feedback type="invalid">{errors.relevantExperience}</Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Current Employment Status *</Form.Label>
//                 <Form.Select name="employmentStatus" value={form.employmentStatus} onChange={handleChange} isInvalid={!!errors.employmentStatus}>
//                   <option value="">Select</option>
//                   {EMPLOYMENT_STATUS.map((s) => <option key={s} value={s}>{s}</option>)}
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">{errors.employmentStatus}</Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Current / Last Company</Form.Label>
//                 <Form.Control type="text" name="currentCompany" value={form.currentCompany} onChange={handleChange} />
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Current / Last Designation</Form.Label>
//                 <Form.Control type="text" name="currentDesignation" value={form.currentDesignation} onChange={handleChange} />
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Current / Last CTC</Form.Label>
//                 <Form.Control type="number" name="currentCTC" min="0" value={form.currentCTC} onChange={handleChange} onWheel={(e) => e.target.blur()} isInvalid={!!errors.currentCTC} />
//                 <Form.Control.Feedback type="invalid">{errors.currentCTC}</Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Expected CTC *</Form.Label>
//                 <Form.Control type="number" name="expectedCTC" min="0" value={form.expectedCTC} onChange={handleChange} onWheel={(e) => e.target.blur()} isInvalid={!!errors.expectedCTC} />
//                 <Form.Control.Feedback type="invalid">{errors.expectedCTC}</Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Notice Period *</Form.Label>
//                 <Form.Select name="noticePeriod" value={form.noticePeriod} onChange={handleChange} isInvalid={!!errors.noticePeriod}>
//                   <option value="">Select</option>
//                   {NOTICE_PERIOD.map((n) => <option key={n} value={n}>{n}</option>)}
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">{errors.noticePeriod}</Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Available to Join From</Form.Label>
//                 <Form.Control
//                   type="date"
//                   name="availableFrom"
//                   value={form.availableFrom}
//                   onChange={handleChange}
//                   min={new Date().toISOString().split('T')[0]}
//                   isInvalid={!!errors.availableFrom}
//                 />
//                 <Form.Control.Feedback type="invalid">{errors.availableFrom}</Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//           </Row>
//         </div>

//         <div className="form-section">
//           {/* 3. Education */}
//           <div className="section-head"><span className="section-num">03</span><h4>Education</h4></div>
//           <Row>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Highest Qualification *</Form.Label>
//                 <Form.Select name="qualification" value={form.qualification} onChange={handleChange} isInvalid={!!errors.qualification}>
//                   <option value="">Select</option>
//                   {QUALIFICATION.map((q) => <option key={q} value={q}>{q}</option>)}
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">{errors.qualification}</Form.Control.Feedback>
//                 {form.qualification === 'Other' && (
//                   <Form.Control
//                     type="text"
//                     name="qualificationOther"
//                     className="mt-2"
//                     placeholder="Please specify qualification"
//                     value={form.qualificationOther}
//                     onChange={handleChange}
//                     isInvalid={!!errors.qualificationOther}
//                   />
//                 )}
//                 {errors.qualificationOther && <div className="text-danger small mt-1">{errors.qualificationOther}</div>}
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Specialization / Degree *</Form.Label>
//                 <Form.Control type="text" name="specialization" value={form.specialization} onChange={handleChange} isInvalid={!!errors.specialization} />
//                 <Form.Control.Feedback type="invalid">{errors.specialization}</Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Institution / University</Form.Label>
//                 <Form.Control type="text" name="institution" value={form.institution} onChange={handleChange} />
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Year of Graduation</Form.Label>
//                 <Form.Select name="graduationYear" value={form.graduationYear} onChange={handleChange}>
//                   <option value="">Select</option>
//                   {GRAD_YEARS.map((y) => <option key={y} value={y}>{y}</option>)}
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>
//         </div>

//         <div className="form-section">
//           {/* 4. Skills & Experience */}
//           <div className="section-head"><span className="section-num">04</span><h4>Skills &amp; Experience</h4></div>
//           <Row>
//             <Col md={12}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Key Skills * <small className="text-muted">(comma separated)</small></Form.Label>
//                 <Form.Control type="text" name="keySkills" value={form.keySkills} onChange={handleChange} onPaste={blockPaste} onKeyDown={blockPasteKey} isInvalid={!!errors.keySkills} placeholder="e.g. SEO, Google Ads, Analytics" />
//                 <Form.Control.Feedback type="invalid">{errors.keySkills}</Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col md={12}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Relevant Skills for the Position *</Form.Label>
//                 <Form.Control as="textarea" rows={3} name="relevantSkillsForPosition" value={form.relevantSkillsForPosition} onChange={handleChange} onPaste={blockPaste} onKeyDown={blockPasteKey} isInvalid={!!errors.relevantSkillsForPosition} />
//                 <Form.Control.Feedback type="invalid">{errors.relevantSkillsForPosition}</Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Years of Relevant Experience *</Form.Label>
//                 <Form.Select name="yearsRelevantExperience" value={form.yearsRelevantExperience} onChange={handleChange} isInvalid={!!errors.yearsRelevantExperience}>
//                   <option value="">Select</option>
//                   {EXPERIENCE_YEARS.map((y) => <option key={y} value={y}>{y}</option>)}
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">{errors.yearsRelevantExperience}</Form.Control.Feedback>
//                 {form.yearsRelevantExperience === 'Others' && (
//                   <Form.Control
//                     type="text"
//                     name="yearsRelevantExperienceOther"
//                     className="mt-2"
//                     placeholder="Please specify"
//                     value={form.yearsRelevantExperienceOther}
//                     onChange={handleChange}
//                     isInvalid={!!errors.yearsRelevantExperienceOther}
//                   />
//                 )}
//                 {errors.yearsRelevantExperienceOther && <div className="text-danger small mt-1">{errors.yearsRelevantExperienceOther}</div>}
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Certifications</Form.Label>
//                 <Form.Control type="text" name="certifications" value={form.certifications} onChange={handleChange} onPaste={blockPaste} onKeyDown={blockPasteKey} />
//               </Form.Group>
//             </Col>
//             <Col md={12}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Professional Achievements</Form.Label>
//                 <Form.Control as="textarea" rows={3} name="achievements" value={form.achievements} onChange={handleChange} onPaste={blockPaste} onKeyDown={blockPasteKey} />
//               </Form.Group>
//             </Col>
//           </Row>
//         </div>

//         <div className="form-section">
//           {/* 5. Resume & Portfolio */}
//           <div className="section-head"><span className="section-num">05</span><h4>Resume &amp; Portfolio</h4></div>
//           <Row>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Upload Resume / CV *</Form.Label>
//                 <InputGroup hasValidation>
//                   <Form.Control ref={resumeRef} type="file" name="resume" accept=".pdf,.doc,.docx" onChange={handleChange} isInvalid={!!errors.resume} />
//                   {form.resume && (
//                     <Button variant="outline-secondary" onClick={() => clearFile('resume', resumeRef)} title="Remove file">
//                       <FaTimes />
//                     </Button>
//                   )}
//                   <Form.Control.Feedback type="invalid">{errors.resume}</Form.Control.Feedback>
//                 </InputGroup>
//                 <Form.Text className="text-muted">Max 5MB.</Form.Text>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Portfolio / Personal Website</Form.Label>
//                 <Form.Control type="url" name="portfolioWebsite" value={form.portfolioWebsite} onChange={handleChange} isInvalid={!!errors.portfolioWebsite} placeholder="https://..." />
//                 <Form.Control.Feedback type="invalid">{errors.portfolioWebsite}</Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Additional Supporting Documents</Form.Label>
//                 <InputGroup>
//                   <Form.Control ref={additionalDocsRef} type="file" name="additionalDocs" onChange={handleChange} />
//                   {form.additionalDocs && (
//                     <Button variant="outline-secondary" onClick={() => clearFile('additionalDocs', additionalDocsRef)} title="Remove file">
//                       <FaTimes />
//                     </Button>
//                   )}
//                 </InputGroup>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>LinkedIn Profile</Form.Label>
//                 <Form.Control type="url" name="linkedin" value={form.linkedin} onChange={handleChange} isInvalid={!!errors.linkedin} placeholder="https://linkedin.com/in/..." />
//                 <Form.Control.Feedback type="invalid">{errors.linkedin}</Form.Control.Feedback>
//               </Form.Group>
//             </Col>
//           </Row>
//         </div>

//         <div className="form-section">
//           {/* 6. Screening Questions */}
//           <div className="section-head"><span className="section-num">06</span><h4>Screening Questions</h4></div>
//           <Row>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Are you comfortable working from our office location? *</Form.Label>
//                 <div>
//                   <Form.Check inline label="Chennai" type="radio" name="comfortableOffice" value="Chennai" checked={form.comfortableOffice === 'Chennai'} onChange={handleChange} />
//                   <Form.Check inline label="Hyderabad" type="radio" name="comfortableOffice" value="Hyderabad" checked={form.comfortableOffice === 'Hyderabad'} onChange={handleChange} />
//                 </div>
//                 {errors.comfortableOffice && <div className="text-danger small">{errors.comfortableOffice}</div>}
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>Are you willing to work according to the requirements of the role? *</Form.Label>
//                 <div>
//                   <Form.Check inline label="Yes" type="radio" name="willingRoleRequirements" value="Yes" checked={form.willingRoleRequirements === 'Yes'} onChange={handleChange} />
//                   <Form.Check inline label="No" type="radio" name="willingRoleRequirements" value="No" checked={form.willingRoleRequirements === 'No'} onChange={handleChange} />
//                 </div>
//                 {errors.willingRoleRequirements && <div className="text-danger small">{errors.willingRoleRequirements}</div>}
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group className="mb-3">
//                 <Form.Label>How did you hear about this job opportunity? *</Form.Label>
//                 <Form.Select name="heardFrom" value={form.heardFrom} onChange={handleChange} isInvalid={!!errors.heardFrom}>
//                   <option value="">Select</option>
//                   {HEARD_FROM.map((h) => <option key={h} value={h}>{h}</option>)}
//                 </Form.Select>
//                 <Form.Control.Feedback type="invalid">{errors.heardFrom}</Form.Control.Feedback>
//                 {form.heardFrom === 'Other' && (
//                   <Form.Control
//                     type="text"
//                     name="heardFromOther"
//                     className="mt-2"
//                     placeholder="Please specify"
//                     value={form.heardFromOther}
//                     onChange={handleChange}
//                     isInvalid={!!errors.heardFromOther}
//                   />
//                 )}
//                 {errors.heardFromOther && <div className="text-danger small mt-1">{errors.heardFromOther}</div>}
//               </Form.Group>
//             </Col>
//             {form.heardFrom === 'Employee Referral' && (
//               <Col md={6}>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Referral Employee Code *</Form.Label>
//                   <Form.Control type="text" name="employeeReferralName" value={form.employeeReferralName} onChange={handleChange} isInvalid={!!errors.employeeReferralName} placeholder="Enter referral employee code" />
//                   <Form.Control.Feedback type="invalid">{errors.employeeReferralName}</Form.Control.Feedback>
//                 </Form.Group>
//               </Col>
//             )}
//           </Row>
//         </div>

//         <div className="form-section">
//           {/* 7. Declaration & Consent */}
//           <div className="section-head"><span className="section-num">07</span><h4>Declaration &amp; Consent</h4></div>
//           <Form.Group className="mb-2">
//             <Form.Check
//               type="checkbox"
//               name="declarationAccuracy"
//               checked={form.declarationAccuracy}
//               onChange={handleChange}
//               isInvalid={!!errors.declarationAccuracy}
//               label="I certify that the information provided in this application is accurate and complete to the best of my knowledge."
//               feedback={errors.declarationAccuracy}
//               feedbackType="invalid"
//             />
//           </Form.Group>
//           <Form.Group className="mb-4">
//             <Form.Check
//               type="checkbox"
//               name="declarationConsent"
//               checked={form.declarationConsent}
//               onChange={handleChange}
//               isInvalid={!!errors.declarationConsent}
//               label="I consent to UEducate Global Pvt. Ltd. using the information provided for recruitment and selection purposes."
//               feedback={errors.declarationConsent}
//               feedbackType="invalid"
//             />
//           </Form.Group>
//         </div>

//         <div className="form-actions">
//           <Button type="submit" variant="primary" size="lg" className="submit-btn me-3" disabled={isSubmitting}>
//             {isSubmitting ? (
//               <>
//                 <Spinner as="span" animation="border" size="sm" role="status" className="me-2" />
//                 Submitting...
//               </>
//             ) : (
//               'Submit Application'
//             )}
//           </Button>
//           <Button type="button" variant="link" className="clear-btn" onClick={handleClearForm} disabled={isSubmitting}>Clear form</Button>
//         </div>
//       </Form>

//       <ToastContainer
//         position="bottom-center"
//         className="p-3"
//         style={{
//           position: 'fixed',
//           bottom: 20,
//           left: '50%',
//           transform: 'translateX(-50%)',
//           zIndex: 9999,
//         }}
//       >
//         <Toast bg="danger" onClose={() => setShowPasteWarning(false)} show={showPasteWarning} delay={2500} autohide>
//           <Toast.Body className="text-white">Cannot able to Paste</Toast.Body>
//         </Toast>
//       </ToastContainer>
//     </Container>
//   );
// };

// export default CareersPage;


import React, { useState, useRef } from 'react';
import { Container, Row, Col, Form, Button, Alert, InputGroup, ToastContainer, Toast, Spinner } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import './CareersPage.css';

// Local Url

// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://192.168.0.83:4001/api/v1';

// Local Url


// Live Url

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.hrms.kpostindia.com/api/v1';

// Live Url


async function submitCareerApplication(formData) {
  const token = JSON.parse(localStorage.getItem('accessToken') || 'null');

  const response = await fetch(`${API_BASE_URL}/careers/apply`, {
    method: 'POST',
    headers: {
      // Do NOT set Content-Type manually for multipart/form-data —
      // the browser sets it automatically with the correct boundary.
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: formData,
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    // response had no JSON body
  }

  if (!response.ok) {
    const message = (data && (data.message || data.error)) || `Request failed with status ${response.status}`;
    const error = new Error(message);
    error.status = response.status;
    error.payload = data;
    throw error;
  }

  return data;
}

const POSITIONS = ['Digital Marketing Executive', 'Motion Graphics Designer', 'Site Engineer', 'Software Developer', 'Sales Executive', 'HR Executive', 'Other'];

// Department -> Role mapping (dependent dropdown)
const DEPARTMENT_ROLES = {
  'Software Development': [
    'Software Engineer', 'Software Developer', 'Application Developer', 'Full Stack Developer', 'Front-End Developer',
    'Back-End Developer', 'Web Developer', 'Mobile App Developer', 'Android Developer', 'iOS Developer', 'React Developer',
    'Angular Developer', 'Vue.js Developer', 'Node.js Developer', '.NET Developer', 'Java Developer', 'Python Developer',
    'PHP Developer', 'Laravel Developer', 'DevOps Developer', 'Embedded Software Developer', 'Game Developer', 'Blockchain Developer'
  ],
  'Software Architecture & Technical Roles': [
    'Solution Architect', 'Software Architect', 'Enterprise Architect', 'Technical Architect', 'Application Architect',
    'Cloud Architect', 'Data Architect', 'Integration Architect', 'Technical Lead', 'Engineering Lead', 'Principal Engineer', 'Staff Engineer'
  ],
  'QA / Software Testing': [
    'QA Engineer', 'QA Analyst', 'Software Tester', 'Manual Tester', 'Automation Tester', 'Test Engineer', 'Automation Test Engineer',
    'Performance Tester', 'Security Tester', 'API Tester', 'Mobile Application Tester', 'QA Lead', 'Test Lead', 'QA Manager', 'Test Manager'
  ],
  'UI/UX & Design': [
    'UI Designer', 'UX Designer', 'UI/UX Designer', 'Product Designer', 'UX Researcher', 'Interaction Designer',
    'Visual Designer', 'Web Designer', 'Design Lead', 'UX Lead'
  ],
  'DevOps / Cloud / Infrastructure': [
    'DevOps Engineer', 'DevOps Lead', 'Site Reliability Engineer (SRE)', 'Cloud Engineer', 'Cloud Architect', 'Cloud Administrator',
    'Infrastructure Engineer', 'Infrastructure Architect', 'Build & Release Engineer', 'Release Manager', 'Platform Engineer',
    'Systems Engineer', 'Systems Administrator', 'Linux Administrator', 'Windows Administrator'
  ],
  'Network & IT Infrastructure': [
    'Network Engineer', 'Network Administrator', 'Network Architect', 'Network Security Engineer', 'Infrastructure Administrator',
    'IT Infrastructure Manager', 'NOC Engineer', 'NOC Manager', 'Wireless Network Engineer', 'Telecom Engineer',
    'Datacenter Engineer', 'Datacenter Manager'
  ],
  'Database & Data': [
    'Database Administrator (DBA)', 'Database Developer', 'Database Engineer', 'Database Architect', 'Data Engineer', 'Data Analyst',
    'Data Scientist', 'Data Architect', 'Big Data Engineer', 'BI Developer', 'Business Intelligence Analyst', 'BI Architect',
    'ETL Developer', 'Data Warehouse Developer', 'Data Quality Analyst', 'Machine Learning Engineer', 'AI Engineer',
    'AI/ML Architect', 'MLOps Engineer'
  ],
  'Business Analysis / Product': [
    'Business Analyst', 'IT Business Analyst', 'Systems Analyst', 'Functional Analyst', 'Technical Business Analyst',
    'Product Analyst', 'Product Manager', 'Technical Product Manager', 'Product Owner', 'Product Lead', 'Project Manager',
    'Program Manager', 'Scrum Master', 'Agile Coach'
  ],
  'Civil Engineering Department': [
    'Chief Civil Engineer', 'Civil Engineering Manager', 'Civil Project Manager', 'Civil Project Engineer', 'Senior Civil Engineer',
    'Civil Engineer', 'Junior Civil Engineer', 'Graduate Civil Engineer', 'Site Engineer', 'Senior Site Engineer', 'Site Supervisor',
    'Construction Manager', 'Construction Engineer', 'Construction Supervisor', 'Structural Engineer', 'Structural Design Engineer',
    'Senior Structural Engineer', 'Structural Analyst', 'Design Engineer', 'Civil Design Engineer', 'Planning Engineer',
    'Project Planning Engineer', 'Estimation Engineer', 'Quantity Surveyor', 'Senior Quantity Surveyor', 'Cost Engineer',
    'Billing Engineer', 'Contracts Engineer', 'Contracts Manager', 'Survey Engineer', 'Land Surveyor', 'Surveyor',
    'Survey Technician', 'Geotechnical Engineer', 'Geotechnical Consultant', 'Highway Engineer', 'Transportation Engineer',
    'Infrastructure Engineer', 'Environmental Engineer', 'Water Resources Engineer', 'Hydraulics Engineer', 'Irrigation Engineer',
    'QA/QC Engineer', 'Civil QA/QC Engineer', 'QA/QC Manager', 'BIM Engineer', 'BIM Modeler', 'BIM Coordinator',
    'Civil CAD Engineer', 'Civil CAD Designer', 'AutoCAD Draftsman', 'Civil Draftsman', 'Safety Engineer', 'HSE Engineer',
    'HSE Manager', 'Construction Safety Officer', 'Site Safety Officer', 'Project Coordinator', 'Civil Consultant',
    'Civil Engineering Consultant'
  ],
  'Mechanical Engineering Department': [
    'Chief Mechanical Engineer', 'Mechanical Engineering Manager', 'Mechanical Project Manager', 'Mechanical Project Engineer',
    'Senior Mechanical Engineer', 'Mechanical Engineer', 'Junior Mechanical Engineer', 'Graduate Mechanical Engineer',
    'Mechanical Design Engineer', 'Senior Mechanical Design Engineer', 'Product Design Engineer', 'Product Development Engineer',
    'Manufacturing Engineer', 'Production Engineer', 'Production Supervisor', 'Production Manager', 'Maintenance Engineer',
    'Senior Maintenance Engineer', 'Maintenance Manager', 'Maintenance Technician', 'Mechanical QA/QC Engineer', 'Quality Engineer',
    'Quality Manager', 'HVAC Engineer', 'HVAC Design Engineer', 'HVAC Technician', 'Thermal Engineer', 'Piping Engineer',
    'Piping Design Engineer', 'Piping Designer', 'Plant Engineer', 'Plant Maintenance Engineer', 'Automotive Engineer',
    'Automotive Design Engineer', 'Automotive Service Engineer', 'Robotics Engineer', 'Automation Engineer', 'Controls Engineer',
    'Mechatronics Engineer', 'Mechanical CAD Engineer', 'Mechanical CAD Designer', 'CAD Modeler', 'CAE Engineer',
    'Simulation Engineer', 'FEA Engineer', 'CFD Engineer', 'Tool Design Engineer', 'Tool & Die Designer', 'Welding Engineer',
    'Welding Inspector', 'Fabrication Engineer', 'Fabrication Supervisor', 'Mechanical Procurement Engineer',
    'Installation Engineer', 'Commissioning Engineer', 'Mechanical Inspector', 'Mechanical Draftsman', 'Mechanical Consultant'
  ],
  'Human Resources (HR)': [
    'Chief Human Resources Officer (CHRO)', 'HR Director', 'HR Head', 'HR Manager', 'Assistant HR Manager', 'HR Executive',
    'Senior HR Executive', 'HR Officer', 'HR Coordinator', 'HR Associate', 'HR Assistant', 'HR Business Partner (HRBP)',
    'Senior HR Business Partner', 'HR Generalist', 'HR Specialist', 'HR Consultant', 'HR Operations Manager', 'HR Operations Executive',
    'HR Operations Specialist', 'HR Compliance Manager', 'HR Compliance Specialist', 'HR Analyst', 'HR Data Analyst', 'HR Information Systems (HRIS) Manager',
    'HRIS Analyst', 'HRIS Administrator', 'HR Intern', 'HR Trainee'
  ],
  'Other': [],
};

const DEPARTMENTS = Object.keys(DEPARTMENT_ROLES);

const EXPERIENCE_YEARS = ['Fresher', '0-1 Years', '1-3 Years', '3-5 Years', '5-8 Years', '8-10 Years', '10+ Years', 'Others'];
const EMPLOYMENT_STATUS = ['Employed', 'Unemployed', 'Serving Notice Period', 'Freelancer'];
const NOTICE_PERIOD = ['Immediate', '15 Days', '30 Days', '60 Days', '90 Days'];
const QUALIFICATION = ['High School', 'Diploma', "Bachelor's Degree", "Master's Degree", 'PhD', 'Other'];
const GRAD_YEARS = Array.from({ length: 40 }, (_, i) => `${new Date().getFullYear() - i}`);
const HEARD_FROM = ['LinkedIn', 'Naukri', 'Indeed', 'Company Website', 'Employee Referral', 'Social Media', 'Other'];

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

const initialState = {
  fullName: '', email: '', mobile: '', location: '', linkedin: '', portfolioWebsite: '',
  position: '', department: '', departmentOther: '', role: '', totalExperience: '', totalExperienceOther: '', relevantExperience: '', employmentStatus: '',
  currentCompany: '', currentDesignation: '', currentCTC: '', expectedCTC: '', noticePeriod: '', availableFrom: '',
  qualification: '', qualificationOther: '', specialization: '', institution: '', graduationYear: '',
  keySkills: '', relevantSkillsForPosition: '', yearsRelevantExperience: '', yearsRelevantExperienceOther: '', certifications: '', achievements: '',
  resume: null, portfolioLink: '', additionalDocs: null,
  comfortableOffice: '', willingRoleRequirements: '', heardFrom: '', heardFromOther: '', employeeReferralName: '',
  declarationAccuracy: false, declarationConsent: false,
};

const CareersPage = () => {
  const [form, setForm] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPasteWarning, setShowPasteWarning] = useState(false);
  const [showFileSizeWarning, setShowFileSizeWarning] = useState(false);
  const resumeRef = useRef(null);
  const additionalDocsRef = useRef(null);

  const blockPaste = (e) => {
    e.preventDefault();
    setShowPasteWarning(true);
  };

  const blockPasteKey = (e) => {
    const isPasteShortcut = (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'v';
    if (isPasteShortcut) {
      e.preventDefault();
      setShowPasteWarning(true);
    }
  };

  const clearFile = (fieldName, ref) => {
    setForm((prev) => ({ ...prev, [fieldName]: null }));
    if (ref.current) ref.current.value = '';
    setErrors((prev) => ({ ...prev, [fieldName]: undefined }));
  };

  const handleClearForm = () => {
    setForm(initialState);
    setErrors({});
    setSubmitError('');
    if (resumeRef.current) resumeRef.current.value = '';
    if (additionalDocsRef.current) additionalDocsRef.current.value = '';
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    // When Department changes, reset the dependent Role field
    if (name === 'department') {
      setForm((prev) => ({ ...prev, department: value, role: '' }));
      setErrors((prev) => ({ ...prev, department: undefined, role: undefined }));
      return;
    }

    // Resume file size check (max 5MB) -> show toast and clear the file input
    if (name === 'resume' && type === 'file' && files[0] && files[0].size > MAX_FILE_SIZE) {
      setShowFileSizeWarning(true);
      e.target.value = '';
      setForm((prev) => ({ ...prev, resume: null }));
      setErrors((prev) => ({ ...prev, resume: undefined }));
      return;
    }

    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : type === 'file' ? files[0] : value,
    }));
  };

  const validate = () => {
    const err = {};
    const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[a-zA-Z]{2,}([\/?#][^\s]*)?$/i;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (!form.fullName.trim()) err.fullName = 'Full Name is required';
    if (!form.email.trim()) err.email = 'Email is required';
    else if (!emailRegex.test(form.email)) err.email = 'Enter a valid email';
    if (!form.mobile.trim()) err.mobile = 'Mobile Number is required';
    else if (!phoneRegex.test(form.mobile)) err.mobile = 'Enter a valid 10-digit mobile number';
    if (!form.location.trim()) err.location = 'Current Location / City is required';
    if (form.linkedin && !urlRegex.test(form.linkedin)) err.linkedin = 'Enter a valid URL';
    if (form.portfolioWebsite && !urlRegex.test(form.portfolioWebsite)) err.portfolioWebsite = 'Enter a valid URL';

    if (!form.position) err.position = 'Position Applied For is required';
    if (!form.department) err.department = 'Department is required';
    if (form.department === 'Other' && !form.departmentOther.trim()) err.departmentOther = 'Please specify department';
    if (form.department !== 'Other' && !form.role) err.role = 'Role is required';
    if (!form.totalExperience) err.totalExperience = 'Total Years of Experience is required';
    if (form.totalExperience === 'Others' && !form.totalExperienceOther.trim()) err.totalExperienceOther = 'Please specify your experience';
    if (!form.relevantExperience.trim()) err.relevantExperience = 'Relevant Experience is required';
    if (!form.employmentStatus) err.employmentStatus = 'Current Employment Status is required';
    if (form.currentCTC && isNaN(Number(form.currentCTC))) err.currentCTC = 'Enter a valid number';
    if (!form.expectedCTC.trim()) err.expectedCTC = 'Expected CTC is required';
    else if (isNaN(Number(form.expectedCTC))) err.expectedCTC = 'Enter a valid number';
    if (!form.noticePeriod) err.noticePeriod = 'Notice Period is required';
    if (form.availableFrom && form.availableFrom < new Date().toISOString().split('T')[0]) {
      err.availableFrom = 'Date cannot be in the past';
    }

    if (!form.qualification) err.qualification = 'Highest Qualification is required';
    if (form.qualification === 'Other' && !form.qualificationOther.trim()) err.qualificationOther = 'Please specify qualification';
    if (!form.specialization.trim()) err.specialization = 'Specialization / Degree is required';

    if (!form.keySkills.trim()) err.keySkills = 'Key Skills are required';
    if (!form.relevantSkillsForPosition.trim()) err.relevantSkillsForPosition = 'This field is required';
    if (!form.yearsRelevantExperience) err.yearsRelevantExperience = 'Years of Relevant Experience is required';
    if (form.yearsRelevantExperience === 'Others' && !form.yearsRelevantExperienceOther.trim()) err.yearsRelevantExperienceOther = 'Please specify years of experience';

    if (!form.resume) err.resume = 'Resume / CV is required';
    else {
      const allowed = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (!allowed.includes(form.resume.type)) err.resume = 'Only PDF/DOC/DOCX allowed';
      else if (form.resume.size > MAX_FILE_SIZE) err.resume = 'File size must be under 5MB';
    }
    if (form.portfolioLink && !urlRegex.test(form.portfolioLink)) err.portfolioLink = 'Enter a valid URL';

    if (!form.comfortableOffice) err.comfortableOffice = 'Please select a location';
    if (!form.willingRoleRequirements) err.willingRoleRequirements = 'Please select Yes or No';
    if (!form.heardFrom) err.heardFrom = 'Please select an option';
    if (form.heardFrom === 'Other' && !form.heardFromOther.trim()) err.heardFromOther = 'Please specify';
    if (form.heardFrom === 'Employee Referral' && !form.employeeReferralName.trim()) err.employeeReferralName = 'Please enter referral name';

    if (!form.declarationAccuracy) err.declarationAccuracy = 'You must certify the information is accurate';
    if (!form.declarationConsent) err.declarationConsent = 'Consent is required to proceed';

    return err;
  };

  const normalizeUrl = (url) => {
    if (!url) return '';
    return /^https?:\/\//i.test(url) ? url : `https://${url}`;
  };

  // Build a FormData object matching the backend's expected field names exactly.
  const buildPayload = () => {
    const data = new FormData();

    // Required text fields
    data.append('fullName', form.fullName);
    data.append('email', form.email);
    data.append('mobile', form.mobile);
    data.append('location', form.location);
    data.append('position', form.position);
    data.append('department', form.department === 'Other' ? form.departmentOther : form.department);
    data.append('totalExperience', form.totalExperience === 'Others' ? form.totalExperienceOther : form.totalExperience);
    data.append('relevantExperience', form.relevantExperience);
    data.append('employmentStatus', form.employmentStatus);
    data.append('expectedCTC', form.expectedCTC);
    data.append('noticePeriod', form.noticePeriod);
    data.append('qualification', form.qualification === 'Other' ? form.qualificationOther : form.qualification);
    data.append('specialization', form.specialization);
    data.append('keySkills', form.keySkills);
    data.append('relevantSkillsForPosition', form.relevantSkillsForPosition);
    data.append('yearsRelevantExperience', form.yearsRelevantExperience === 'Others' ? form.yearsRelevantExperienceOther : form.yearsRelevantExperience);
    data.append('comfortableOffice', form.comfortableOffice);
    data.append('willingRoleRequirements', form.willingRoleRequirements);
    data.append('heardFrom', form.heardFrom === 'Other' ? form.heardFromOther : form.heardFrom);

    // Required file
    data.append('resume', form.resume);

    // Optional fields — only append when they have a value
    if (form.linkedin) data.append('linkedin', normalizeUrl(form.linkedin));
    if (form.portfolioWebsite) data.append('portfolioWebsite', normalizeUrl(form.portfolioWebsite));
    if (form.department !== 'Other' && form.role) data.append('role', form.role);
    if (form.currentCompany) data.append('currentCompany', form.currentCompany);
    if (form.currentDesignation) data.append('currentDesignation', form.currentDesignation);
    if (form.currentCTC) data.append('currentCTC', form.currentCTC);
    if (form.availableFrom) data.append('availableFrom', form.availableFrom);
    if (form.institution) data.append('institution', form.institution);
    if (form.graduationYear) data.append('graduationYear', form.graduationYear);
    if (form.certifications) data.append('certifications', form.certifications);
    if (form.achievements) data.append('achievements', form.achievements);
    if (form.portfolioLink) data.append('portfolioLink', normalizeUrl(form.portfolioLink));
    if (form.heardFrom === 'Employee Referral' && form.employeeReferralName) {
      data.append('employeeReferralName', form.employeeReferralName);
    }
    if (form.additionalDocs) data.append('additionalDocs', form.additionalDocs);

    return data;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');

    const err = validate();
    setErrors(err);
    if (Object.keys(err).length !== 0) {
      // scroll to the first invalid field for convenience
      const firstErrorField = document.querySelector('.is-invalid');
      if (firstErrorField) firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    setIsSubmitting(true);
    try {
      const payload = buildPayload();
      await submitCareerApplication(payload);

      setSubmitted(true);
      setForm(initialState);
      if (resumeRef.current) resumeRef.current.value = '';
      if (additionalDocsRef.current) additionalDocsRef.current.value = '';
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      console.error('Submission error:', error);
      setSubmitError(error.message || 'Something went wrong while submitting. Please try again.');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container className="careers-page py-5">
      <div className="careers-header">
        <p style={{ marginTop: "60px" }} className="mb-3 d-flex justify-content-center eyebrow">Join UEducate</p>
        <h2 style={{ textAlign: "center" }}>Career Application Form</h2>
        <p className="subtext">
          This application is designed to help us understand your professional profile, 
          skills, experience, qualifications, and career aspirations. 
          The information provided will be used to assess your suitability 
          for current or future career opportunities and to support a 
          fair and effective recruitment process.
        </p>
      </div>

      {submitted && <Alert variant="success" onClose={() => setSubmitted(false)} dismissible>Application submitted successfully! Our team will get back to you shortly.</Alert>}
      {submitError && <Alert variant="danger" onClose={() => setSubmitError('')} dismissible>{submitError}</Alert>}

      <Form noValidate onSubmit={handleSubmit}>
        <div className="form-section">
          {/* 1. Personal Information */}
          <div className="section-head"><span className="section-num">01</span><h4>Personal Information</h4></div>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Full Name *</Form.Label>
                <Form.Control type="text" name="fullName" value={form.fullName} onChange={handleChange} isInvalid={!!errors.fullName} />
                <Form.Control.Feedback type="invalid">{errors.fullName}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Email Id *</Form.Label>
                <Form.Control type="email" name="email" value={form.email} onChange={handleChange} isInvalid={!!errors.email} />
                <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Mobile Number *</Form.Label>
                <Form.Control
                  type="tel"
                  name="mobile"
                  value={form.mobile}
                  onChange={(e) => {
                    const digitsOnly = e.target.value.replace(/\D/g, '').slice(0, 10);
                    setForm((prev) => ({ ...prev, mobile: digitsOnly }));
                  }}
                  isInvalid={!!errors.mobile}
                  placeholder="10-digit number"
                  maxLength={10}
                  inputMode="numeric"
                />
                <Form.Control.Feedback type="invalid">{errors.mobile}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Current Location / Address *</Form.Label>
                <Form.Control type="text" name="location" value={form.location} onChange={handleChange} isInvalid={!!errors.location} />
                <Form.Control.Feedback type="invalid">{errors.location}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </div>

        <div className="form-section">
          {/* 2. Job Information */}
          <div className="section-head"><span className="section-num">02</span><h4>Job Information</h4></div>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Position Applied For *</Form.Label>
                <Form.Control as="textarea" rows={2} name="position" value={form.position} onChange={handleChange} isInvalid={!!errors.position} placeholder="Enter Your Position.." />
                <Form.Control.Feedback type="invalid">{errors.position}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Department *</Form.Label>
                <Form.Select name="department" value={form.department} onChange={handleChange} isInvalid={!!errors.department}>
                  <option value="">Select</option>
                  {DEPARTMENTS.map((d) => <option key={d} value={d}>{d}</option>)}
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.department}</Form.Control.Feedback>
                {form.department === 'Other' && (
                  <Form.Control
                    type="text"
                    name="departmentOther"
                    className="mt-2"
                    placeholder="Please specify department"
                    value={form.departmentOther}
                    onChange={handleChange}
                    isInvalid={!!errors.departmentOther}
                  />
                )}
                {errors.departmentOther && <div className="text-danger small mt-1">{errors.departmentOther}</div>}
              </Form.Group>
            </Col>

            {/* Role dropdown - depends on selected Department. Hidden when Department is 'Other' */}
            {form.department !== 'Other' && (
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Role *</Form.Label>
                  <Form.Select
                    name="role"
                    value={form.role}
                    onChange={handleChange}
                    isInvalid={!!errors.role}
                    disabled={!form.department}
                  >
                    <option value="">
                      {form.department ? 'Select' : 'Select Department First'}
                    </option>
                    {(DEPARTMENT_ROLES[form.department] || []).map((r) => (
                      <option key={r} value={r}>{r}</option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">{errors.role}</Form.Control.Feedback>
                </Form.Group>
              </Col>
            )}

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Total Years of Experience *</Form.Label>
                <Form.Select name="totalExperience" value={form.totalExperience} onChange={handleChange} isInvalid={!!errors.totalExperience}>
                  <option value="">Select</option>
                  {EXPERIENCE_YEARS.map((y) => <option key={y} value={y}>{y}</option>)}
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.totalExperience}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            {form.totalExperience === 'Others' && (
              <>
                <Col md={12}>
                  <Form.Control
                    type="text"
                    name="totalExperienceOther"
                    className="mt-2 mb-4"
                    placeholder="Please specify"
                    value={form.totalExperienceOther}
                    onChange={handleChange}
                    isInvalid={!!errors.totalExperienceOther}
                  />
                </Col>
                {errors.totalExperienceOther && <div className="text-danger small mt-1">{errors.totalExperienceOther}</div>}
              </>
            )}

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Relevant Experience *</Form.Label>
                <Form.Control type="text" name="relevantExperience" value={form.relevantExperience} onChange={handleChange} isInvalid={!!errors.relevantExperience} placeholder="e.g. 2 years in Digital Marketing" />
                <Form.Control.Feedback type="invalid">{errors.relevantExperience}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Current Employment Status *</Form.Label>
                <Form.Select name="employmentStatus" value={form.employmentStatus} onChange={handleChange} isInvalid={!!errors.employmentStatus}>
                  <option value="">Select</option>
                  {EMPLOYMENT_STATUS.map((s) => <option key={s} value={s}>{s}</option>)}
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.employmentStatus}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Current / Last Company</Form.Label>
                <Form.Control type="text" name="currentCompany" value={form.currentCompany} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Current / Last Designation</Form.Label>
                <Form.Control type="text" name="currentDesignation" value={form.currentDesignation} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Current / Last CTC</Form.Label>
                <Form.Control type="number" name="currentCTC" min="0" value={form.currentCTC} onChange={handleChange} onWheel={(e) => e.target.blur()} isInvalid={!!errors.currentCTC} />
                <Form.Control.Feedback type="invalid">{errors.currentCTC}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Expected CTC *</Form.Label>
                <Form.Control type="number" name="expectedCTC" min="0" value={form.expectedCTC} onChange={handleChange} onWheel={(e) => e.target.blur()} isInvalid={!!errors.expectedCTC} />
                <Form.Control.Feedback type="invalid">{errors.expectedCTC}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Notice Period *</Form.Label>
                <Form.Select name="noticePeriod" value={form.noticePeriod} onChange={handleChange} isInvalid={!!errors.noticePeriod}>
                  <option value="">Select</option>
                  {NOTICE_PERIOD.map((n) => <option key={n} value={n}>{n}</option>)}
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.noticePeriod}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Available to Join From</Form.Label>
                <Form.Control
                  type="date"
                  name="availableFrom"
                  value={form.availableFrom}
                  onChange={handleChange}
                  min={new Date().toISOString().split('T')[0]}
                  isInvalid={!!errors.availableFrom}
                />
                <Form.Control.Feedback type="invalid">{errors.availableFrom}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </div>

        <div className="form-section">
          {/* 3. Education */}
          <div className="section-head"><span className="section-num">03</span><h4>Education</h4></div>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Highest Qualification *</Form.Label>
                <Form.Select name="qualification" value={form.qualification} onChange={handleChange} isInvalid={!!errors.qualification}>
                  <option value="">Select</option>
                  {QUALIFICATION.map((q) => <option key={q} value={q}>{q}</option>)}
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.qualification}</Form.Control.Feedback>
                {form.qualification === 'Other' && (
                  <Form.Control
                    type="text"
                    name="qualificationOther"
                    className="mt-2"
                    placeholder="Please specify qualification"
                    value={form.qualificationOther}
                    onChange={handleChange}
                    isInvalid={!!errors.qualificationOther}
                  />
                )}
                {errors.qualificationOther && <div className="text-danger small mt-1">{errors.qualificationOther}</div>}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Specialization / Degree *</Form.Label>
                <Form.Control type="text" name="specialization" value={form.specialization} onChange={handleChange} isInvalid={!!errors.specialization} />
                <Form.Control.Feedback type="invalid">{errors.specialization}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Institution / University</Form.Label>
                <Form.Control type="text" name="institution" value={form.institution} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Year of Graduation</Form.Label>
                <Form.Select name="graduationYear" value={form.graduationYear} onChange={handleChange}>
                  <option value="">Select</option>
                  {GRAD_YEARS.map((y) => <option key={y} value={y}>{y}</option>)}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </div>

        <div className="form-section">
          {/* 4. Skills & Experience */}
          <div className="section-head"><span className="section-num">04</span><h4>Skills &amp; Experience</h4></div>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Key Skills * <small className="text-muted">(comma separated)</small></Form.Label>
                <Form.Control type="text" name="keySkills" value={form.keySkills} onChange={handleChange} onPaste={blockPaste} onKeyDown={blockPasteKey} isInvalid={!!errors.keySkills} placeholder="e.g. SEO, Google Ads, Analytics" />
                <Form.Control.Feedback type="invalid">{errors.keySkills}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Relevant Skills for the Position *</Form.Label>
                <Form.Control as="textarea" rows={3} name="relevantSkillsForPosition" value={form.relevantSkillsForPosition} onChange={handleChange} onPaste={blockPaste} onKeyDown={blockPasteKey} isInvalid={!!errors.relevantSkillsForPosition} />
                <Form.Control.Feedback type="invalid">{errors.relevantSkillsForPosition}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Years of Relevant Experience *</Form.Label>
                <Form.Select name="yearsRelevantExperience" value={form.yearsRelevantExperience} onChange={handleChange} isInvalid={!!errors.yearsRelevantExperience}>
                  <option value="">Select</option>
                  {EXPERIENCE_YEARS.map((y) => <option key={y} value={y}>{y}</option>)}
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.yearsRelevantExperience}</Form.Control.Feedback>
                {form.yearsRelevantExperience === 'Others' && (
                  <Form.Control
                    type="text"
                    name="yearsRelevantExperienceOther"
                    className="mt-2"
                    placeholder="Please specify"
                    value={form.yearsRelevantExperienceOther}
                    onChange={handleChange}
                    isInvalid={!!errors.yearsRelevantExperienceOther}
                  />
                )}
                {errors.yearsRelevantExperienceOther && <div className="text-danger small mt-1">{errors.yearsRelevantExperienceOther}</div>}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Certifications</Form.Label>
                <Form.Control type="text" name="certifications" value={form.certifications} onChange={handleChange} onPaste={blockPaste} onKeyDown={blockPasteKey} />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Professional Achievements</Form.Label>
                <Form.Control as="textarea" rows={3} name="achievements" value={form.achievements} onChange={handleChange} onPaste={blockPaste} onKeyDown={blockPasteKey} />
              </Form.Group>
            </Col>
          </Row>
        </div>

        <div className="form-section">
          {/* 5. Resume & Portfolio */}
          <div className="section-head"><span className="section-num">05</span><h4>Resume &amp; Portfolio</h4></div>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Upload Resume / CV *</Form.Label>
                <InputGroup hasValidation>
                  <Form.Control ref={resumeRef} type="file" name="resume" accept=".pdf,.doc,.docx" onChange={handleChange} isInvalid={!!errors.resume} />
                  {form.resume && (
                    <Button variant="outline-secondary" onClick={() => clearFile('resume', resumeRef)} title="Remove file">
                      <FaTimes />
                    </Button>
                  )}
                  <Form.Control.Feedback type="invalid">{errors.resume}</Form.Control.Feedback>
                </InputGroup>
                <Form.Text className="text-muted">Max 5MB.</Form.Text>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Portfolio / Personal Website</Form.Label>
                <Form.Control type="url" name="portfolioWebsite" value={form.portfolioWebsite} onChange={handleChange} isInvalid={!!errors.portfolioWebsite} placeholder="https://..." />
                <Form.Control.Feedback type="invalid">{errors.portfolioWebsite}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Additional Supporting Documents</Form.Label>
                <InputGroup>
                  <Form.Control ref={additionalDocsRef} type="file" name="additionalDocs" onChange={handleChange} />
                  {form.additionalDocs && (
                    <Button variant="outline-secondary" onClick={() => clearFile('additionalDocs', additionalDocsRef)} title="Remove file">
                      <FaTimes />
                    </Button>
                  )}
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>LinkedIn Profile</Form.Label>
                <Form.Control type="url" name="linkedin" value={form.linkedin} onChange={handleChange} isInvalid={!!errors.linkedin} placeholder="https://linkedin.com/in/..." />
                <Form.Control.Feedback type="invalid">{errors.linkedin}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </div>

        <div className="form-section">
          {/* 6. Screening Questions */}
          <div className="section-head"><span className="section-num">06</span><h4>Screening Questions</h4></div>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Are you comfortable working from our office location? *</Form.Label>
                <div>
                  <Form.Check inline label="Chennai" type="radio" name="comfortableOffice" value="Chennai" checked={form.comfortableOffice === 'Chennai'} onChange={handleChange} />
                  <Form.Check inline label="Hyderabad" type="radio" name="comfortableOffice" value="Hyderabad" checked={form.comfortableOffice === 'Hyderabad'} onChange={handleChange} />
                </div>
                {errors.comfortableOffice && <div className="text-danger small">{errors.comfortableOffice}</div>}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Are you willing to work according to the requirements of the role? *</Form.Label>
                <div>
                  <Form.Check inline label="Yes" type="radio" name="willingRoleRequirements" value="Yes" checked={form.willingRoleRequirements === 'Yes'} onChange={handleChange} />
                  <Form.Check inline label="No" type="radio" name="willingRoleRequirements" value="No" checked={form.willingRoleRequirements === 'No'} onChange={handleChange} />
                </div>
                {errors.willingRoleRequirements && <div className="text-danger small">{errors.willingRoleRequirements}</div>}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>How did you hear about this job opportunity? *</Form.Label>
                <Form.Select name="heardFrom" value={form.heardFrom} onChange={handleChange} isInvalid={!!errors.heardFrom}>
                  <option value="">Select</option>
                  {HEARD_FROM.map((h) => <option key={h} value={h}>{h}</option>)}
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.heardFrom}</Form.Control.Feedback>
                {form.heardFrom === 'Other' && (
                  <Form.Control
                    type="text"
                    name="heardFromOther"
                    className="mt-2"
                    placeholder="Please specify"
                    value={form.heardFromOther}
                    onChange={handleChange}
                    isInvalid={!!errors.heardFromOther}
                  />
                )}
                {errors.heardFromOther && <div className="text-danger small mt-1">{errors.heardFromOther}</div>}
              </Form.Group>
            </Col>
            {form.heardFrom === 'Employee Referral' && (
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Referral Employee Code *</Form.Label>
                  <Form.Control type="text" name="employeeReferralName" value={form.employeeReferralName} onChange={handleChange} isInvalid={!!errors.employeeReferralName} placeholder="Enter referral employee code" />
                  <Form.Control.Feedback type="invalid">{errors.employeeReferralName}</Form.Control.Feedback>
                </Form.Group>
              </Col>
            )}
          </Row>
        </div>

        <div className="form-section">
          {/* 7. Declaration & Consent */}
          <div className="section-head"><span className="section-num">07</span><h4>Declaration &amp; Consent</h4></div>
          <Form.Group className="mb-2">
            <Form.Check
              type="checkbox"
              name="declarationAccuracy"
              checked={form.declarationAccuracy}
              onChange={handleChange}
              isInvalid={!!errors.declarationAccuracy}
              label="I certify that the information provided in this application is accurate and complete to the best of my knowledge."
              feedback={errors.declarationAccuracy}
              feedbackType="invalid"
            />
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Check
              type="checkbox"
              name="declarationConsent"
              checked={form.declarationConsent}
              onChange={handleChange}
              isInvalid={!!errors.declarationConsent}
              label="I consent to UEducate Global Pvt. Ltd. using the information provided for recruitment and selection purposes."
              feedback={errors.declarationConsent}
              feedbackType="invalid"
            />
          </Form.Group>
        </div>

        <div className="form-actions">
          <Button type="submit" variant="primary" size="lg" className="submit-btn me-3" disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <Spinner as="span" animation="border" size="sm" role="status" className="me-2" />
                Submitting...
              </>
            ) : (
              'Submit Application'
            )}
          </Button>
          <Button type="button" variant="link" className="clear-btn" onClick={handleClearForm} disabled={isSubmitting}>Clear form</Button>
        </div>
      </Form>

      <ToastContainer
        position="bottom-center"
        className="p-3"
        style={{
          position: 'fixed',
          bottom: 20,
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 9999,
        }}
      >
        <Toast bg="danger" onClose={() => setShowPasteWarning(false)} show={showPasteWarning} delay={2500} autohide>
          <Toast.Body className="text-white">Cannot able to Paste</Toast.Body>
        </Toast>

        <Toast bg="danger" onClose={() => setShowFileSizeWarning(false)} show={showFileSizeWarning} delay={3000} autohide>
          <Toast.Body className="text-white">File Size Must Be Under 5MB.</Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
};

export default CareersPage;